import { uuidV4 } from '../lib/helpers'
import BaseProxy from './Proxy.js'

class SupportProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/v22/support', parameters)
  }

  sendMessage({ email, message }) {
    const data = { email, message }
    const randomId = uuidV4()

    return this.submit('post', `${this.endpoint}/requests/${randomId}`, data)
  }
}

export default SupportProxy
